<template>
  <div class="img-container">
    <img
      src="@/assets/images/common/welcome-banner.png"
      alt="Banner"
      class="banner"
    />
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.img-container {
  width: 50%;
  position: fixed;
  top: 0;
  right: 0;
  @media screen and (max-width: 768px) {
    display: none;
    width: 0px;
  }
}
.banner {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}
</style>
